import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, FlowGrid, H1, Image, LayoutBand, MarginBox, Paragraph, Row, Separator } from '@fs/zion-ui'
import { useHistory } from '@fs/zion-router'
import { LogoFamilysearch } from '@fs/zion-icon'
import findImage from './images/find.jpg'
import peopleImage from './images/people.jpg'
import { MemoriesPageHead } from '../../components'

const communityLink = 'https://community.familysearch.org/en/group/347-memories-people-and-find-pages'

export default function Feedback() {
  const [t] = useTranslation()
  const history = useHistory()

  const peoplePage = history?.location?.pathname?.includes('people')

  return (
    <>
      <MemoriesPageHead page={peoplePage ? 'people' : 'find'} />
      <LayoutBand>
        <Separator size="xl" />
        <MarginBox marginX="xxl">
          <FlowGrid>
            <H1 size="H3">
              {peoplePage
                ? t('memories.feedback.people.title', 'Looking for the People page?')
                : t('memories.feedback.find.title', 'Looking for the Find Memories page?')}
            </H1>
            <Paragraph size="sm">
              {peoplePage
                ? t(
                    'memories.feedback.people.body',
                    'The People Memories page is currently unavailable as we upgrade to improved technology.'
                  )
                : t(
                    'memories.feedback.find.body',
                    'The Find Memories page is currently unavailable as we upgrade to improved technology.'
                  )}
            </Paragraph>
            <Paragraph size="sm">
              {t(
                'memories.feedback.body',
                "As part of this update, we're also deciding whether to bring the page back in the future. If you've enjoyed using is this feature, we'd love to hear from you. Please share your thoughts in the Community."
              )}
            </Paragraph>
            <Button Icon={LogoFamilysearch} to={communityLink}>
              {t('memories.feedback.community.button', 'Go To Community')}
            </Button>
          </FlowGrid>
        </MarginBox>
        <Separator />
        <Row alignX="center">
          <Image
            aria-hidden="true"
            src={peoplePage ? peopleImage : findImage}
            alt=""
            maxWidth={1200}
            draggable="false"
          />
        </Row>
        <Separator size="nano" />
      </LayoutBand>
    </>
  )
}
